import "styled-components";

const autumnTheme = {
  layout: {
    background: `   
    url("${process.env.PUBLIC_URL}/assets/images/background/leaves.png") no-repeat bottom center,
    radial-gradient(circle, #6f4634, #472a1d)`,
  },
  header: {
    fontColor: "#ebd9cb",
    background: `linear-gradient(to right, transparent, rgba(56, 33, 23, 0.9), transparent)`,
  },
  footer: {
    fontColor: "#decebe",
  },
  switcher: {
    background: `linear-gradient(to right, transparent, rgba(222,200,185, 0.6), transparent)`,
    headerBackgroundColor: "#382117",
    bodyBackgroundColor: "#6f4634",
    hoverColor: "#e1aca9",
    fontColor: "#ebe3d8",
    buttonFontColor: "#decebe",
  },
  calendar: {
    backgroundColors: {
      emptyCell: "#dec8b9",
      mainCell: "#ffeddb",
      dayOfWeekCell: "#fbe9db",
    },
    fontColors: {
      main: "#9f8a6f",
      empty: "#c0bdb9",
      day: "#6f604d",
      sunday: "#d58985",
    },
  },
};

// #9aadb5

export default autumnTheme;
